import { Card, Col, Row , PageHeader, Tag} from 'antd'
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { menu } from '../actions/common'

export const Welcome = (props) => {
    return (
        <>
        <PageHeader
                title="Welcome.."
                className="site-page-header no-print"
                subTitle=""
                tags={<Tag color="blue">Active</Tag>}
                extra={[,]}
                avatar={{ src: process.env.PUBLIC_URL+'/asset/icons/home.png' }}    
            ></PageHeader>
        <div className="site-card-wrapper" style={{paddingBlock:'1vh'}}>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                {
                    menu.map((prop, id)=>{
                        const {name, link, icon} = prop
                        return <Col key={id} className="gutter-row" xs={24} xl={6}>
                            <Link to={`/home${link}`}>
                            <Card bordered={false} className="maincard">
                            <Row>
                                <Col>
                                {name}
                                </Col>
                            </Row>
                            <Row className="text-center bg-info" style={{ alignItems: 'center'}}>
                                <Col span={24} className="text-center" style={{ alignItems: 'center'}}>
                                    <img 
                                        height='80px'
                                        alt="school logo" 
                                        src={process.env.PUBLIC_URL+ '/asset/icons/'+icon} 
                                        onError={(e)=>{
                                            e.target.onerror=null; 
                                            e.target.src=process.env.PUBLIC_URL+'/asset/img/defaultlogo.png'
                                        } }
                                        />
                                </Col>
                            </Row>
                            </Card>
                        </Link>
                         </Col>
                    })
                }
            </Row>
        </div>
        </>
    )
}

const mapStateToProps = (state) => ({
    
})

const mapDispatchToProps = {
    
}

export default connect(mapStateToProps, mapDispatchToProps)(Welcome)
